import ChatOpener from './styled';

export default ChatOpener;
